<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="identity_check_score"
        v-model="whitePagesData.identity_check_score"
        label="Identity Check Score"
        hint="Less than 250 passes"
        persistent-hint
        type="number"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="country_code"
        v-model="whitePagesData.ip_address_checks.geolocation.country_code"
        label="Country Code"
        hint="Country code US passes"
        persistent-hint
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="identity_network_score"
        v-model="whitePagesData.identity_network_score"
        label="Identity Network Score"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
      <v-text-field
        id="is_commercial"
        v-model="whitePagesData.primary_address_checks.is_commercial"
        label="Address is Commercial"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    whitePagesData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
